export default {
  root: {
    background: '#ffffff',
    fontSize: '15px',
    fontWeight: 'bold'
  }
}
